// Компонент для отображения трех значений: текущее, прошлое, динамика
import {FallOutlined, MinusOutlined, RiseOutlined} from "@ant-design/icons";
import {Card, Tag} from "antd";

const TripleValueDisplay = ({
                                current,
                                last,
                                dynamic,
                                format = 'number',
                                size = 'default',
                                currentLabel,
                                lastLabel
                            }) => {
    // Получение подписей периодов
    const getPeriodLabels = () => {
        const currentYear = new Date().getFullYear();
        return {
            current: currentLabel || `${currentYear}`,
            last: lastLabel || `${currentYear - 1}`
        };
    };

    // Конфигурация динамики
    const getDynamicConfig = (value) => {
        if (!value && value !== 0) return {color: '', icon: <MinusOutlined/>, label: 'Нет данных'};
        const num = Number(value);
        if (num > 0) return {color: '#309604', icon: <RiseOutlined/>, label: `+${num.toFixed(1)}%`};
        if (num < 0) return {color: '#ff0404', icon: <FallOutlined/>, label: `${num.toFixed(1)}%`};
        return {color: '', icon: <MinusOutlined/>, label: '0%'};
    };

    // Форматирование значений
    const formatValue = (value, type) => {
        if (!value && value !== 0) return '-';

        switch (type) {
            case 'currency':
                return `${Number(value).toLocaleString('ru-RU', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                })} €`;
            case 'hours':
                return `${Number(value).toLocaleString('ru-RU', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                })} ч`;
            case 'number':
            default:
                return Number(value).toLocaleString('ru-RU');
        }
    };

    const periodLabels = getPeriodLabels();
    const dynamicConfig = getDynamicConfig(dynamic);
    const isSmall = size === 'small';

    return (
        <div

        >
            <div style={{
                padding: '0'
            }}>
                {/* Основные значения */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: '10px',
                }}>
                    {/* Текущий период */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'baseline',
                    }}>
                        <div style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            color: '#1890ff'
                        }}>
                          {formatValue(current, format)}
                        </div>
                        <div style={{
                            fontSize: isSmall ? '12px' : '13px',
                            color: '#8c8c8c',
                            fontStyle: 'italic'
                        }}>
              {formatValue(last, format) + ` в ${periodLabels.last} году`}
            </div>
                    </div>
                </div>

                {/* Динамика */}
                <div style={{
position: 'absolute',
                    top: 5,
                    right: 5,
                    fontWeight: 'bold',
                    color: dynamicConfig.color
                }}>
                    {dynamicConfig.label}
                </div>
            </div>
        </div>
    );
};

export default TripleValueDisplay